import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { POST_SALES_APARTMENT } from "./type";

export const postApartment = (leadId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.postSales.appartment}${leadId}`
  );
  if (res) {
    const outer = res.data;
    const payload = outer?.response ?? outer;
    const data = payload?.data ?? outer?.data;
    dispatch({ type: POST_SALES_APARTMENT, payload: data });
    return data;
  }
};
